import {Routes} from '@angular/router';

export const PROFILE_ROUTES:Routes=[

   
     {
        path:"",
        loadChildren:()=>import('../profile/profile.module').then(m=>m.ProfileModule)
    }
]